import { ActionCreator, MemoizedSelector, Action } from '@ngrx/store';

import { DomainInfo, DomainStatisticsFilterConverted } from 'mbs-ui-shared@models/domain.model';
import { EntityStateModel } from '../pagingStoreFactory/pagingStoreTypes';
import { StoreTypes } from '../storeTypes.enum';

export type CustomDomainsStoreProperties = {
  restrictedNames: string[];
  loadedRestrictedNames: boolean;
  domainStatistic: DomainStatisticsFilterConverted;
  loadedDomainStatistic: boolean;
  loadingDomainStatistic: boolean;
};

export enum DomainsStoreCustomActionsTypes {
  loadRestrictedNames = `Load Restricted Names`,
  setRestrictedNames = `Set Restricted Names`,
  loadDomainStatistic = `Load Domain Statistic`,
  setDomainStatistic = `Set Domain Statistic`
}

export type DomainsStoreCustomActionsType = `[${StoreTypes}] ${DomainsStoreCustomActionsTypes}`;

export type DomainsCustomActionTypes = {
  loadRestrictedNames: ActionCreator<
    DomainsStoreCustomActionsType,
    (props: { force?: boolean }) => { force?: boolean } & Action<DomainsStoreCustomActionsType>
  >;
  setRestrictedNames: ActionCreator<
    DomainsStoreCustomActionsType,
    (props: { restrictedNames: string[] }) => { restrictedNames: string[] } & Action<DomainsStoreCustomActionsType>
  >;
  loadDomainStatistic: ActionCreator<
    DomainsStoreCustomActionsType,
    (props: { force?: boolean }) => { force?: boolean } & Action<DomainsStoreCustomActionsType>
  >;
  setDomainStatistic: ActionCreator<
    DomainsStoreCustomActionsType,
    (props: {
      domainStatistic: DomainStatisticsFilterConverted;
    }) => { domainStatistic: DomainStatisticsFilterConverted } & Action<DomainsStoreCustomActionsType>
  >;
};

export type DomainsCustomSelectorTypes = {
  selectRestrictedNames: MemoizedSelector<EntityStateModel<DomainInfo, CustomDomainsStoreProperties>, string[]>;
  selectLoadedRestrictedNames: MemoizedSelector<EntityStateModel<DomainInfo, CustomDomainsStoreProperties>, boolean>;
  selectDomainStatistic: MemoizedSelector<EntityStateModel<DomainInfo, CustomDomainsStoreProperties>, DomainStatisticsFilterConverted>;
  selectLoadedDomainStatistic: MemoizedSelector<EntityStateModel<DomainInfo, CustomDomainsStoreProperties>, boolean>;
  selectLoadingDomainStatistic: MemoizedSelector<EntityStateModel<DomainInfo, CustomDomainsStoreProperties>, boolean>;
};
